import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Package, ChevronDown, Pencil, Trash2, Plus } from 'lucide-react';

export function BrandManager({ brands, products, onRename, onDelete, onAdd }) {
  const [showBrands, setShowBrands] = useState(false);
  const [editingBrand, setEditingBrand] = useState(null);
  const [editBrandValue, setEditBrandValue] = useState('');

  const handleRename = (oldName) => {
    if (!editBrandValue.trim() || editBrandValue === oldName) {
      setEditingBrand(null);
      return;
    }
    onRename(oldName, editBrandValue.trim());
    setEditingBrand(null);
  };

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-sm mb-6">
      <button
        onClick={() => setShowBrands(!showBrands)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-zinc-800/50 transition-colors"
        data-testid="toggle-brands"
      >
        <div className="flex items-center gap-2">
          <Package className="h-4 w-4 text-[#78BE20]" />
          <span className="text-white font-medium text-sm">Brands</span>
          <span className="text-zinc-500 text-xs">({brands.length})</span>
        </div>
        <ChevronDown className={`h-4 w-4 text-zinc-400 transition-transform ${showBrands ? 'rotate-180' : ''}`} />
      </button>
      {showBrands && (
        <div className="border-t border-zinc-800 p-4">
          <div className="space-y-2">
            {brands.map(brand => (
              <div key={brand} className="flex items-center gap-2" data-testid={`brand-${brand}`}>
                {editingBrand === brand ? (
                  <>
                    <Input
                      value={editBrandValue}
                      onChange={(e) => setEditBrandValue(e.target.value)}
                      className="flex-1 h-8 bg-zinc-800 border-zinc-700 text-sm"
                      onKeyDown={(e) => e.key === 'Enter' && handleRename(brand)}
                    />
                    <Button size="sm" className="h-8 bg-[#78BE20] text-black hover:bg-[#65a31b]" onClick={() => handleRename(brand)}>Save</Button>
                    <Button size="sm" variant="outline" className="h-8 border-zinc-700" onClick={() => setEditingBrand(null)}>Cancel</Button>
                  </>
                ) : (
                  <>
                    <span className="flex-1 text-white text-sm">{brand}</span>
                    <span className="text-zinc-600 text-xs">{products.filter(p => p.brand === brand).length} products</span>
                    <Button variant="ghost" size="sm" className="h-7 px-2 text-zinc-400 hover:text-white" onClick={() => { setEditingBrand(brand); setEditBrandValue(brand); }}>
                      <Pencil className="h-3 w-3" />
                    </Button>
                    <Button variant="ghost" size="sm" className="h-7 px-2 text-zinc-400 hover:text-red-400" onClick={() => onDelete(brand)}>
                      <Trash2 className="h-3 w-3" />
                    </Button>
                  </>
                )}
              </div>
            ))}
          </div>
          <Button
            size="sm"
            variant="outline"
            className="mt-3 border-zinc-700 text-zinc-400"
            onClick={onAdd}
          >
            <Plus className="h-3 w-3 mr-1" /> Add Brand
          </Button>
        </div>
      )}
    </div>
  );
}
